import * as React from 'react';

import { Translate } from '@decorators';

import {
	EBrandFileName,
	EBrandImage,
} from '../../enums';
import { IBrandPageProps } from '../../types';
import { BrandBaseElementsScreen } from '../BrandBaseElementsScreen';

@Translate('common.containers.Brand.components.BrandPatternsScreen')
export class BrandPatternsScreen extends React.Component<IBrandPageProps> {

	render() {
		const {
			isMobile,
			brand: {
				fileSizes: {
					patterns: fileSize,
				},
			},
			urls: {
				brandDownload,
				imagePath,
			},
			onDownloadButtonClick,
		} = this.props;

		const count = isMobile ? 5 : 9;

		const images = [
			EBrandImage.PATTERN_01,
			EBrandImage.PATTERN_02,
			EBrandImage.PATTERN_03,
			EBrandImage.PATTERN_04,
			EBrandImage.PATTERN_05,
			EBrandImage.PATTERN_06,
			EBrandImage.PATTERN_07,
			EBrandImage.PATTERN_08,
			EBrandImage.PATTERN_09,
			EBrandImage.PATTERN_10,
			EBrandImage.PATTERN_11,
			EBrandImage.PATTERN_12,
			EBrandImage.PATTERN_13,
			EBrandImage.PATTERN_14,
			EBrandImage.PATTERN_15,
			EBrandImage.PATTERN_16,
			EBrandImage.PATTERN_17,
			EBrandImage.PATTERN_18,
		].sort(() => 0.5 - Math.random()) // biased, not optimal shuffle - it's ok
			.slice(0, count)
			.map((image) => `${imagePath}/patterns/${image}.svg`);

		return (
			<BrandBaseElementsScreen
				isMobile={isMobile}
				downloadFileSize={fileSize}
				downloadLinkUrl={`${brandDownload}/${EBrandFileName.PATTERNS}.zip`}
				downloadTitle={this.t('downloadAll')}
				images={images}
				onDownloadButtonClick={onDownloadButtonClick}
			/>
		);
	}

}
